import { Prettify } from '../../lib/typeUtils';

export type PropertyGetter<Entity, Value> = (entity: Entity) => Value;

// This is basically `curryRight` but slightly more specialized and type-safe
// enab;es us to have setter functions that work both as (entity, value) => entity for regular use
// and (value) => (entity) => entity for use in pipes for composition
export type PropertySetter<Entity, Value> = {
  (entity: Entity, value: Value | null): Entity;
  (value: Value | null): (entity: Entity) => Entity;
};

export const createPropertySetter = <Entity, Value>(
  fn: (entity: Entity, value: Value | null) => Entity
): PropertySetter<Entity, Value> => {
  const curried = (
    arg1: Entity | Value | null,
    arg2?: Value | null
  ): Entity | ((entity: Entity) => Entity) => {
    if (arg2 !== undefined) {
      return fn(arg1 as Entity, arg2);
    }

    return (entity: Entity) => fn(entity, arg1 as Value | null);
  };

  return curried as PropertySetter<Entity, Value>;
};

export type PropertiesManager<ManagedObject, Entity> = Prettify<
  {
    [K in keyof ManagedObject & string]: PropertyGetter<
      Entity,
      ManagedObject[K]
    >;
  } & {
    [K in keyof ManagedObject &
      string as `set${Capitalize<K>}`]: PropertySetter<
      Entity,
      ManagedObject[K]
    >;
  }
>;
